import { NumberBox } from '@card/commonlib';
import React from 'react';
import styled from 'styled-components';
import { Currency as CurrencyType } from '@card/types';

const TotalWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 8px;
`;

export interface TotalNumberBoxProps {
  currency: CurrencyType;
  title: string;
  value?: number;
}

const TotalNumberBox = ({ title, value, currency }: TotalNumberBoxProps) => {
  return (
    <TotalWrapper>
      <NumberBox currency={currency} title={title} value={value} variant="coralSLight" />
    </TotalWrapper>
  );
};

export default TotalNumberBox;
